import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { Storage } from "@ionic/storage";
import {
  ToastController,
  LoadingController,
  Platform,
  AlertController,
  MenuController,
} from "@ionic/angular";
import { Network } from "@ionic-native/network/ngx";
import { Login } from "../models/Login";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";

@Component({
  selector: "app-check-otp",
  templateUrl: "./check-otp.page.html",
  styleUrls: ["./check-otp.page.scss"],
})
export class CheckOTPPage implements OnInit {
  loginInfo: Login;
  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  isLoggedIn: false;
  token: any;
  pwdHide: true;
  loader: any;
  logindata: any;
  otpmobile: any;
  fcmToken: any;
  otp:any;

  constructor(
    private router: Router,
    private storage: Storage,
    public toastController: ToastController,
    private network: Network,
    public loadingController: LoadingController,
    public helper: Helper,
    private apiservice: APIService,
    private splashScreen: SplashScreen,
    private alertCtrl: AlertController,
    private platform: Platform,
    private formBuilder: FormBuilder,
    private menuCtrl: MenuController
  ) {
    // this.platform.ready().then(() => {
    //   this.fcm.getToken().then(token => {
    //     console.log("new fcm token", token);
    //     this.storage.set("fcmToken",token);
    //     this.fcmToken = token;
    //    });

    //   });

    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(["tabs/tab1"]);
    });

    this.credentialsForm = this.formBuilder.group({
      otp: ["", [Validators.required, Validators.minLength(8)]],
    });

    this.loginInfo = new Login();
  }
  ngOnInit() {}

  ionViewWillEnter() {
    this.storage.get("otpmobile").then((otpmobile) => {
      this.storage.get("fcmToken").then((fcmToken) => {
        this.otpmobile = otpmobile;
        this.fcmToken = fcmToken;
        console.log("otpmobile", this.otpmobile);
        console.log("fcmToken check otp", this.fcmToken);
      });
    });
  }

  checkotp(value: any) {
    console.log("login function");
    if (!value.otp || !this.credentialsForm.controls.otp.valid) {
      this.helper.presentToastError("Please Enter Valid OTP!");

      // tslint:disable-next-line:triple-equals
    } else if (
      !(this.network.type !== "none" && this.network.type !== "unknown")
    ) {
      this.helper.presentToastError("Please on Internet Connection!");
    } else {
      /*Call API For Login*/
      /*this.helper.showLoader('Processing');*/
      this.presentLoading().then(() => {
        let data;
        if (this.fcmToken) {
          data = {
            phone: this.otpmobile,
            FcmToken: this.fcmToken,
            otp: value.otp.toString(),
          };
        } else {
          data = {
            phone: this.otpmobile,
            otp: value.otp.toString(),
          };
        }

        this.apiservice.PatentNewOtpLogin(data).subscribe(
          (response) => {
            console.log("responseBody", response.body);
            // this.successvalue = JSON.stringify(response.body);
            if (response.body.status == "success") {
              this.logindata = response.body.result;

              this.storage.set("email", this.logindata.email);
              this.storage.set("dob", this.logindata.dob);
              this.storage.set("age", this.logindata.age);
              // this.storage.set('email', this.logindata.body.email);
              this.storage.set("gender", this.logindata.gender);
              this.storage.set("firstname", this.logindata.firstname);
              this.storage.set("lastname", this.logindata.lastname);
              this.storage.set("phone", this.logindata.phone);
              this.storage.set("status", this.logindata.status);
              this.storage.set("vytalId", this.logindata.vytalId);
              this.storage.set("tokenData", this.logindata._id);
              this.router.navigate(["tabs/tab1"]);
              this.helper.presentToastSuccess("Login Successful!");
              this.menuCtrl.enable(true);
              this.dismissLoading();
            } else {
              this.dismissLoading();
              this.helper.presentToastError("OTP does not match");
            }
            return response;
          },
          (error) => {
            this.dismissLoading();
            this.helper.presentToastError("Something went wrong!");
          }
        );
      });
    }
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }

  async exitapp() {
    const me = this;
    const alert = await this.alertCtrl.create({
      header: "Exit App",
      message: "Are you sure you want to exit app?",
      buttons: [
        {
          text: "No",
          role: "no",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            (navigator as any).app.exitApp();
          },
        },
      ],
    });
    await alert.present();
  }
}
